export default class {
    /**
     * Create a random string
     *
     * @see https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
     *
     * @param nbChars
     * @returns {string|string}
     */
    static getRandomString(nbChars) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < nbChars; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    /**
     * Slugify text
     *
     * @see https://gist.github.com/mathewbyrne/1280286
     *
     * @param text
     */
    static slugify(text) {
        return text.toString().replace(/([A-Z])/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "").toLowerCase().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    }

    /**
     * Uppercase first letter of a string
     * @param string
     * @returns {string}
     */
    static ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
}
